export const UK_PARTS_SUPPLIERS = [
    'Euro Car Parts',
    'GSF Car Parts',
    'Halfords Trade',
    'Andrew Page',
    'Partco',
    'Alliance Automotive',
    'Unipart',
    'TPS',
    'Motor Factor',
    'Pirtek',
] as const;
